import { render, staticRenderFns } from "./formTexterea.vue?vue&type=template&id=c33d831e"
import script from "./formTexterea.vue?vue&type=script&lang=js"
export * from "./formTexterea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports